<template>
  <Transition name="modal">
    <div v-if="showModal" id="modalAccessRestricted">
      <div class="modal-mask"></div>
      <div class="modal-container">
        <div class="modal-header">
          <button class="close-black" @click="close()">
            <img
              src="https://api.belladasemana.com.br/storage/2015/ico_x_black-t.png"
              alt="Close"
              class="close-modal"
            />
          </button>
        </div>
        <div class="modal-body text-center">
          <div v-html="htmlContent" class="restricted-content"></div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
const props = defineProps<{
  showModal: boolean;
  htmlContent: string;
}>();

const emit = defineEmits<{
  (e: 'close'): void;
}>();

function close() {
  emit('close');
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  transition: opacity 0.3s ease;
}

.modal-container {
  position: fixed;
  z-index: 9999;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 550px;
  max-width: 95%;
  margin: auto;
  padding: 40px 30px;
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  border: 1px solid transparent;
  border-radius: 54px;
  background:
    linear-gradient(white, white) padding-box,
    linear-gradient(to bottom, #FF6000, #FFC39E) border-box;
  background-clip: padding-box, border-box;
  background-origin: padding-box, border-box;
}

.modal-header {
  display: block;
  text-align: center;
}

.modal-body {
  margin: 0;
  padding: 0;
}

.restricted-content {
  color: #000;
  font-family: "Exo-2", Arial, sans-serif;
  font-size: 18px;
  line-height: 1.4;
  padding: 16px 8px;
}

.modal-enter-from {
  opacity: 0;
}

.modal-leave-to {
  opacity: 0;
}

.modal-enter-from .modal-container,
.modal-leave-to .modal-container {
  -webkit-transform: translate(-50%, -50%) scale(1.1);
  transform: translate(-50%, -50%) scale(1.1);
}

.close-black {
  position: absolute;
  right: -25px;
  top: -56px;
  z-index: 1;
  background: transparent;
  border: 0;
  cursor: pointer;
}

@media screen and (max-width: 769px) {
  .modal-container {
    width: 95%;
    border-radius: 30px;
    padding: 30px 16px;
  }

  .close-modal {
    width: 25px;
    height: 25px;
    margin: 5px;
  }

  .restricted-content {
    font-size: 16px;
  }

  .close-black {
    right: -10px;
    top: -50px;
  }
}
</style>
